var dom = require('js-utils/dom');

var currentX = 0;
var currentMouseX = 0;
var currentY = 0;
var currentMouseY = 0;

function onMouseMove(e) {
	currentMouseX = e.clientX;
	currentMouseY = e.clientY;
}

function updateTransform() {
	var oldX = currentX;
	var oldY = currentY;
	currentX = currentX * 0.9 + currentMouseX * 0.1;
	currentY = currentY * 0.9 + currentMouseY * 0.1;

	if (Math.abs(currentX - oldX) > 1 || Math.abs(currentY - oldY) > 1) {
		dom.forEach(dom.all('.gradient'), m => {
			var degreeY = -( currentX / 200) + 12;
			var degreeX = -( currentY / 140) - 15;
			var attr = 'perspective(1500px) rotateY(' + degreeY + 'deg) rotateZ(-2deg) rotateX(' + degreeX + 'deg)';
			m.style.transform = attr;
			m.style.webkitTransform = attr;
		});
	}
}

dom.on('mousemove', onMouseMove);
setInterval(updateTransform, 25);
